require('./transfersLandingView.scss');

const PropTypes = require('prop-types');

// @ vendor
const React = require('react');
const { connect } = require('react-redux');
const PureRenderMixin = require('react-addons-pure-render-mixin');
// @ helpers
const { FormattedText, formatText } = require('core/i18n').i18n;
const { contactCenterClassName, conditionalClassName } = require('utilities/conditionals/conditionalClassname')

// @ commons
const { OKButton } = require('components/commons/OKButton/OKButton');
const { OKCover } = require('commonsComponents/OKCover');
const { OKSectionBox } = require('commonsComponents/OKSectionBox');
const OKHeaderLanding = require('components/commons/OKHeaderLanding/OKHeaderLanding');
const { CommercialAdsCCValidated: CommercialAds } = require('components/commons/commercialAds/commercialAds');

// @ components
const { EmitedTransfersSummary } = require('components/transfers/emited/emitedTransfersSummary/emitedTransfersSummary');
const { ScheduledTransfersSummary } = require('components/transfers/scheduled/scheduledTransfersSummary/scheduledTransfersSummary');
const TransfersMoreOptionsButton = require('components/transfers/transfersMoreOptionsButton/transfersMoreOptionsButton');
const TransfersOptionsButton = require('components/transfers/transfersOptionsButton/transfersOptionsButton');
const TransfersPaymentsAbroadInfo = require('components/transfers/transfersPaymentsAbroadInfo/transfersPaymentsAbroadInfo');
const TutorialLauncher = require('components/tutorial/tutorialLauncher');
const { CallMeBack } = require('components/callMeBack/callMeBack');
const { TransfersAgendaSummary } = require('components/transfers/transfersAgenda/transfersAgendaSummary/transfersAgendaSummary');
const ContactCenterRender = require('components/conditionalRender/contactCenterRender')
const WebappRender = require('components/conditionalRender/webappRender')

// @ actions
const scheduledTransfersActions = require('actions/scheduledTransfers');
const emitedTransfersActions = require('actions/emitedTransfers');
const cancelBizumActions = require('actions/contactCenter/cancelBizum');

// @constants
const { GRAPHIC_TUTOR_TYPE_2 } = require('constants/index');
const { WEB_INACTIVE_ACCOUNT_ENABLED } = require('constants/flagBasedFeatures');
const ERROR_CODES = require('constants/contactCenter/cancelBizumErrorCodes');

class TransfersLandingView extends React.Component {
    constructor(props) {
        super(props);

        this.shouldComponentUpdate = PureRenderMixin.shouldComponentUpdate.bind(this);
    }


    componentDidMount() {
        if (__CONTACT_CENTER__) {
            this.props.queryContract();
        }
    }

    buildQuickAccessPanel() {
        if (__CONTACT_CENTER__) return null
        return (
            <div className="transfers-landing-view__quick-access-panel">
                <h2 className="transfers-landing-view__quick-access-panel-title">
                    <FormattedText value="transfersLanding-quickAccessTitle" />
                </h2>
                <div className="transfers-landing-view__quick-access-panel-button">
                    <OKButton
                        modifier="secondary"
                        to="/myprofile/transfers/transfer"
                        block={true}
                    >
                        <FormattedText value="transfersOptions-makeNationalTransfer" />
                    </OKButton>
                </div>
                <div className="transfers-landing-view__quick-access-panel-button">
                    <OKButton
                        modifier="secondary"
                        to="/myprofile/transfers/pass"
                        block={true}
                    >
                        <FormattedText value="transfersOptions-makePass" />
                    </OKButton>
                </div>
            </div>
        )
    }

    buildCCQuickAccessButtons() {
        if (!__CONTACT_CENTER__) return null

        // This links should be updated from the method this.buildQuickAccessPanel
        this.quickAccessLinks = [
            {
                link: '/myprofile/transfers/transfer',
                text: formatText('transfersOptions-makeNationalTransfer')
            },
            {
                link: '/myprofile/transfers/pass',
                text: formatText('transfersOptions-makePass')
            }
        ]

        return (
            this.quickAccessLinks.map((item) =>
            (<div key={item.text} className="btn-group transfers-landing-view__quick-access-topbar-button">
                <OKButton
                    modifier="ghost-inverse"
                    to={item.link}
                    block
                >
                    {item.text}
                </OKButton>
            </div>)
            )
        )
    }

    hasBizumActive(immCancelBizum) {
        const fetchError = immCancelBizum.get('fetchError');
        const fetchErrorCode = immCancelBizum.get('fetchErrorCode');
        let hasBizumActive = !this.doestHaveBizumActive(fetchError, fetchErrorCode);

        return hasBizumActive;
    }

    doestHaveBizumActive(fetchError, fetchErrorCode) {
        return fetchError && fetchErrorCode === ERROR_CODES.CONTRACT_NOT_FOUND;
    }

    render() {
        const {
            immAccounts,
            immEmitedTransfers,
            immFlagBasedFeatures,
            immScheduledTransfers,
            immScreen,
            immCancelBizum,
            requestEmitedTransfers,
            requestScheduledTransfers,
        } = this.props;

        const title = formatText('transfersLanding-transfers');
        const quickAccessPanel = this.buildQuickAccessPanel();
        const ccQuickAccessButtons = this.buildCCQuickAccessButtons()
        const tutorial = (
            <TutorialLauncher
                type={GRAPHIC_TUTOR_TYPE_2}
                title={formatText('tutorials-transfersTitle')}
            />
        );
        let moreOptionsButton;
        let optionsButton;
        let scheduledTransfers;
        let transfersAgendaSummary;
        let emitedTransfersSummary;
        const isInactiveAccountsEnabled = immFlagBasedFeatures.get(WEB_INACTIVE_ACCOUNT_ENABLED);
        const hasBizumActive = __CONTACT_CENTER__ && this.hasBizumActive(immCancelBizum);

        if (immAccounts && immAccounts.get('byOrder').get(0)) {
            const immAccount = immAccounts.get('byId').get(immAccounts.get('byOrder').get(0));
            moreOptionsButton = (<TransfersMoreOptionsButton immAccount={immAccount} />);
            optionsButton = (<TransfersOptionsButton hasBizumActive={hasBizumActive} immAccount={immAccount} />);
            scheduledTransfers = (
                <ScheduledTransfersSummary
                    immAccounts={immAccounts}
                    immScheduledTransfers={immScheduledTransfers}
                    immScreen={immScreen}
                    isInactiveAccountsEnabled={isInactiveAccountsEnabled}
                    requestScheduledTransfers={requestScheduledTransfers}
                />
            );
            transfersAgendaSummary = (
                <TransfersAgendaSummary
                    immAccount={immAccount}
                    immScreen={immScreen}
                />
            );
            emitedTransfersSummary = (
                <EmitedTransfersSummary
                    immAccounts={immAccounts}
                    immEmitedTransfers={immEmitedTransfers}
                    immScreen={immScreen}
                    isInactiveAccountsEnabled={isInactiveAccountsEnabled}
                    requestEmitedTransfers={requestEmitedTransfers}
                />
            );
        }

        const transfersLandingClassName = contactCenterClassName('transfers-landing-view__body', 'grid-view__body')
        const transfersLandingLeftClassName = conditionalClassName('col-xs-12', 'transfers-landing-view__left-column col-xs-6', 'col-md-9-cc-6')
        const transfersLandingRightClassName = conditionalClassName('col-xs-12', 'transfers-landing-view__right-column col-xs-6', 'col-md-3-cc-6')
        const transfersLandingWrapperFooter = contactCenterClassName('transfers-landing-view__wrapper-footer', 'container-fluid grid-view__cross-selling')

        return (
            <div>
                <div className="container-fluid">
                    <div className="row">
                        <OKCover size="small" section="transfers" customClass="col-xs-12">
                            <OKHeaderLanding title={title} tutorial={tutorial} inputClassName="ok-header-landing--transfers no-gutter">
                                {moreOptionsButton}
                                <ContactCenterRender>
                                    {ccQuickAccessButtons}
                                </ContactCenterRender>
                                {optionsButton}
                            </OKHeaderLanding>
                        </OKCover>
                    </div>
                </div>
                <div className={transfersLandingClassName}>
                    <div className="container-fluid grid-view--content-position-positive">
                        <div className="row">
                            <div className={transfersLandingLeftClassName}>
                                <div className="row">
                                    <div className="col-md-12">
                                        <div className="transfers-landing-view__main-content">
                                            {transfersAgendaSummary}
                                        </div>
                                        <WebappRender>
                                            <div className="transfers-landing-view__main-content">
                                                {scheduledTransfers}
                                            </div>
                                        </WebappRender>
                                        <div className="transfers-landing-view__main-content">
                                            {emitedTransfersSummary}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className={transfersLandingRightClassName}>
                                <div className="row">
                                    <WebappRender>
                                        <div className="col-xs-12 col-sm-4 col-md-12 grid-view--variable-cell-separation">
                                            <OKSectionBox>
                                                {quickAccessPanel}
                                            </OKSectionBox>
                                        </div>
                                        <div className="col-xs-12 col-sm-4 col-md-12 grid-view--fix-cell-separation">
                                            <CommercialAds path="transfers" type="banner-b" />
                                        </div>
                                    </WebappRender>
                                    <ContactCenterRender>
                                        <div className="col-xs-12 col-sm-4 col-md-12 grid-view--variable-cell-separation">
                                            <div className="transfers-landing-view__main-content">
                                                {scheduledTransfers}
                                            </div>
                                        </div>
                                    </ContactCenterRender>
                                    <div className="col-xs-12 col-sm-4 col-md-12">
                                        <div className="row">
                                            <div className="col-xs-12 grid-view--fix-cell-separation">
                                                <TransfersPaymentsAbroadInfo />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-xs-12 col-sm-4 col-md-12 grid-view--fix-cell-separation">
                                        <CallMeBack isSmall={true} pageTitle={title} hasEntrance={false} />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <WebappRender>
                    <div className={transfersLandingWrapperFooter}>
                        <div className="row">
                            <CommercialAds path="transfers" type="cross-selling" />
                        </div>
                    </div>
                </WebappRender>
            </div>
        );
    }
}

TransfersLandingView.propTypes = {
    immAccounts: PropTypes.object.isRequired,
    immEmitedTransfers: PropTypes.object.isRequired,
    immFlagBasedFeatures: PropTypes.object.isRequired,
    immScheduledTransfers: PropTypes.object.isRequired,
    immScreen: PropTypes.object.isRequired,
    immCancelBizum: PropTypes.object.isRequired,
    requestEmitedTransfers: PropTypes.func.isRequired,
    requestScheduledTransfers: PropTypes.func.isRequired,
    queryContract: PropTypes.func.isRequired,
};

module.exports.constructor = TransfersLandingView;
module.exports.TransfersLandingView = connect(
    state => ({
        immAccounts: state.accounts,
        immScreen: state.screen,
        immScheduledTransfers: state.scheduledTransfers,
        immEmitedTransfers: state.emitedTransfers,
        immFlagBasedFeatures: state.flagBasedFeatures,
        immCancelBizum: state.cancelBizum
    }), {
    requestScheduledTransfers: scheduledTransfersActions.requestScheduledTransfers,
    requestEmitedTransfers: emitedTransfersActions.requestEmitedTransfers,
    queryContract: cancelBizumActions.queryContract
})(TransfersLandingView);
